import Intro from './Intro';
import Intro2 from './Intro2';
import LogicGameIntro from './LogicGameIntro';
import LogicGame from './LogicGame';
import LogicGameOutro from './LogicGameOutro';

export default [Intro, Intro2, LogicGameIntro, LogicGame, LogicGameOutro];
